/**
 * The phase of a day - morning, afternoon, or evening.
 */
export enum PhaseOfDay {
  Morning,
  Afternoon,
  Evening,
}

/**
 * Computes the phase of the day given the date.
 */
export function computePhaseOfDay(date: Date) {
  const hours = date.getHours()

  if (hours >= 0 && hours < 12) {
    return PhaseOfDay.Morning
  } else if (hours >= 12 && hours < 18) {
    return PhaseOfDay.Afternoon
  } else {
    return PhaseOfDay.Evening
  }
}
